const WikiCitySalleCeremonieInformation = () =>
  import(
    '@/views/wiki/communes/form/tabs/salleCeremonie/form/tabs/information/WikiCitySalleCeremonieInformation.vue'
  )
const WikiCitySalleCeremonieFormsTabsComponent = () =>
  import(
    '@/views/wiki/communes/form/tabs/salleCeremonie/form/WikiCitySalleCeremonieFormsTabsComponent.vue'
  )
const WikiCitySalleCeremonieIndexPage = () =>
  import(
    '@/views/wiki/communes/form/tabs/salleCeremonie/index/WikiCitySalleCeremonieIndexPage.vue'
  )
const WikiPlaceItemsTab = () =>
  import('@/views/wiki/communes/form/tabs/components/WikiPlaceItemsTab.vue')
const WikiPlaceTranslationTab = () =>
  import(
    '@/views/wiki/communes/form/tabs/components/WikiPlaceTranslationTab.vue'
  )
const WikiPlaceContactTab = () =>
  import('@/views/wiki/communes/form/tabs/components/WikiPlaceContactTab.vue')

export const wikiCitySalleCeremonieRoutes = [
  {
    path: 'salle_ceremonie',
    children: [
      {
        path: '',
        name: 'wiki_edit_city_salle_ceremonie_page_route',
        component: WikiCitySalleCeremonieIndexPage,
        props: true,
        meta: {
          pre_page: '',
          next_page: ''
        }
      },
      {
        path: ':salle_ceremonie_id',
        name: 'wiki_city_edit_salle_ceremonie_page_route',
        component: WikiCitySalleCeremonieFormsTabsComponent,
        props: true,
        children: [
          {
            path: '',
            name: 'wiki_city_edit_salle_ceremonie_information_page_route',
            component: WikiCitySalleCeremonieInformation
          },
          {
            path: 'translation',
            name: 'wiki_city_edit_salle_ceremonie_translation_page_route',
            component: WikiPlaceTranslationTab
          },
          {
            path: 'contact',
            name: 'wiki_city_edit_salle_ceremonie_contact_page_route',
            component: WikiPlaceContactTab
          },
          {
            path: 'items',
            name: 'wiki_city_edit_salle_ceremonie_items_page_route',
            component: WikiPlaceItemsTab
          }
        ],
        meta: {
          type: 'edit'
        }
      },
      {
        path: 'new',
        name: 'wiki_city_create_salle_ceremonie_page_route',
        component: WikiCitySalleCeremonieFormsTabsComponent,
        children: [
          {
            path: '',
            name: 'wiki_city_create_salle_ceremonie_information_page_route',
            component: WikiCitySalleCeremonieInformation
          },
          {
            path: 'translation',
            name: 'wiki_city_create_salle_ceremonie_translation_page_route',
            component: WikiPlaceTranslationTab
          },
          {
            path: 'contact',
            name: 'wiki_city_create_salle_ceremonie_contact_page_route',
            component: WikiPlaceContactTab
          },
          {
            path: 'items',
            name: 'wiki_city_create_salle_ceremonie_items_page_route',
            component: WikiPlaceItemsTab
          }
        ],
        meta: {
          type: 'create'
        }
      }
    ]
  }
]
